class SummonUs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let formValidated = [];

    function postForm(urlData) {
      fetch('https://liquid-death.gigalixirapp.com/v2/support/', {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(urlData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (window.Shopify.customerPrivacy.marketingAllowed()) {
            amzn('trackEvent', 'Contact');
          }
          document.querySelector('#thank-you-modal').classList.remove('hidden');
        })
        .catch((error) => {
          alert(error);
        });
    }

    this.querySelector('#question-type').addEventListener('change', (e) => {
      if (e.target.value == 'wholesale') {
        this.querySelector('#subject').placeholder = 'Business Location';
        this.querySelector('#order-number').placeholder = 'Business Type';
      } else {
        if (this.querySelector('#subject').placeholder == 'Business Location') {
          this.querySelector('#subject').placeholder = 'Subject';
          this.querySelector('#order-number').placeholder = 'Order Number';
        }
      }
    });

    this.querySelector('.button-submit').addEventListener('click', (e) => {
      e.preventDefault();
      const data = {
        customer_email: document.querySelector('#email').value,
        customer_message: document.querySelector('#message').value,
        customer_name: document.querySelector('#full-name').value,
        region: 'us',
        subject: document.querySelector('#subject').value,
        type: document.querySelector('#question-type').value,
      };
      const urlData = data;
      this.querySelectorAll('input').forEach((e, index) => {
        if (e.reportValidity() == false) {
          formValidated[index] = false;
        } else {
          formValidated[index] = true;
        }
      });

      let checker = (arr) => arr.every(Boolean);
      if (checker(formValidated) == false) {
      } else {
        postForm(urlData);
      }
    });
  }
}
customElements.define('summon-us', SummonUs);
